export const HUBSPOT_INTEGRATION = 'hubspot'
export const PIPEDRIVE_INTEGRATION = 'pipedrive'
export const ZOHO_INTEGRATION = 'zoho'
export const SALESFORCE_INTEGRATION = 'salesforce'
export const GUESTY_INTEGRATION = 'guesty'
export const HIGHLEVEL_INTEGRATION = 'highlevel'
// The list-import modal keys off the lowercased screen name, the rest of the app off this one.
export const GOHIGHLEVEL_INTEGRATION = 'gohighlevel'
export const CLIO_MANAGE_INTEGRATION = 'clio-manage'

// A CRM's screen name and icon, keyed the way a phone number's links are serialized.
export const CRM_BADGES = {
  [HUBSPOT_INTEGRATION]: { name: 'HubSpot', icon: 'hubspot' },
  [SALESFORCE_INTEGRATION]: { name: 'Salesforce', icon: 'salesforce' },
  [ZOHO_INTEGRATION]: { name: 'Zoho', icon: 'zoho' },
  [PIPEDRIVE_INTEGRATION]: { name: 'Pipedrive', icon: 'pipedrive' },
  [GOHIGHLEVEL_INTEGRATION]: { name: 'HighLevel', icon: 'gohighlevel' },
  [GUESTY_INTEGRATION]: { name: 'Guesty', icon: 'guesty' },
  [CLIO_MANAGE_INTEGRATION]: { name: 'Clio Manage', icon: 'clio-manage' }
}
